// extracted by mini-css-extract-plugin
export default {"nextBtn":"styles_nextBtn__Uqh1+"};